import React, { useState } from 'react';
import '../scss/components/section.scss';
import Header from '.././components/header/header.jsx';
import PageTitle from '../components/page-title/page-title-v1';
import Flathelp from '../components/flat-help';
import Footer from '../components/footer/footer-v1';
import dataFooter from '../assets/fake-data/data-footer';
import Bottom from '../components/bottom';
import { Link } from "react-router-dom";
import img1 from '../assets/images/icon/icon1.svg';
import img2 from '../assets/images/icon/icon2.svg';
import img3 from '../assets/images/icon/icon3.svg';
import img4 from '../assets/images/mark/architecture.jpeg';
import { BsDisplay } from 'react-icons/bs';
function ServiceMap(props) {

    const [dataContact] = useState(
        [
            {
                img: img1,
                text: 'Deep and real-time insight',
                adress: 'By NextInsight',
            },
            {
                img: img2,
                text: 'Integration of data sources',
                adress: 'By NextData',
            },
            {
                img: img3,
                text: 'Bulk personalized content',
                adress: 'By NextContent',
            },
            {
                img: img3,
                text: 'Timely crisis management',
                adress: 'By NextCrisis',
            }
        ]
    )

    return (
        <section className="tf-section tf-map">
            <div className="container">
                <div className="row">
                    <div className="col-md-12" style={{ textAlign: 'center' }}>
                        <div >
                            <img src={img4}></img>
                        </div>
                        <div className="box-adderss" >
                            <div className="inner-box flex-one">
                                {
                                    dataContact.map((item, index) => (
                                        <div className="post flex" key={index}>
                                            <div className="content">
                                                <p className="text-color-1">{item.text}</p>
                                                <Link className="fw-4 fs-20" to="tel:+123456789">{item.adress}</Link>
                                            </div>
                                        </div>
                                    ))
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default ServiceMap;